module.exports = __webpack_public_path__ + "static/media/loader.8f1d872e.png";